import React from 'react';
import Chart from "react-apexcharts";

import { creditCardData } from './Components/CreditCardsData'
import { CardExpenseChart } from './Components/CardExpenseChart';
import { CardListData } from './Components/CardListData';
import { CardSettingData } from './Components/CardSetting';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';

const CreditCards = () => {

    return (
        <div>
            {/*  x---------------------------------x My Cards Section x---------------------------------x */}
            <div className="row g-sm-3 g-1 row-deck flex-wrap py-4 justify-content-center">
                <div className="row justify-content-sm-start justify-content-between align-items-center">
                    <h3 className="col text-dark fs-5 fw-semibold mb-0">My Cards</h3>
                    <Link to="/" className="col text-dark text-end fs-5 fw-semibold d-block d-sm-none ">see
                        all</Link>
                </div>
                {creditCardData.map((data, index) => {
                    return (
                        // x---------------------------------x My ATM Cards x---------------------------------x 
                        <div className="col-xl-4 col-lg-6 col-md-6" key={index} >
                            <div className="card border-0 bg-transparent h-100">
                                <div className={`rounded-4 ${data.bg_color}`}>
                                    <div className="card-body  rounded-bottom-0 rounded-4">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h5 className={`card-title ${data.text_color} fs-6 fw-normal font-family-Lato`}>
                                                    Balance</h5>
                                                <span
                                                    className={`${data.text_color} card-text fs-3 fw-normal font-family-Lato`}
                                                >
                                                    $ <CountUp end={data.value} duration={2.5} start={0} />
                                                </span>
                                            </div>
                                            <div>
                                                <div className="card-img">
                                                    {data.cardIcon}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center py-4">
                                            <div>
                                                <h5 className={`${data.text_color} fs-6 fw-normal font-family-Lato`}>CARD
                                                    HOLDER</h5>
                                                <h4 className={`card-text ${data.text_color} ${data.fontsSize} fw-normal font-family-Lato`}>
                                                    {data.name}</h4>
                                            </div>
                                            <div>
                                                <h5
                                                    className={`${data.text_color} text-opacity-75 fs-6 fw-normal font-family-Lato`}>
                                                    VALID THRU</h5>
                                                <h4 className={`card-text ${data.text_color} fs-3 fw-normal font-family-Lato`}>
                                                    {data.expiry}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer rounded-bottom-4">
                                        <div className="d-flex justify-content-between align-items-center py-2">
                                            <div>
                                                <h4 className={`card-text ${data.text_color} fs-3 fw-normal font-family-Lato`}>
                                                    {data.cardNumber}</h4>
                                            </div>
                                            <div>
                                                <div className="card-img">
                                                    {data.f_icon}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {/*  x---------------------------------x Card Expense/Card List Section x---------------------------------x */}
            <div className="row g-sm-3 g-1 row-deck">
                {/*  x---------------------------------x Card Expense x---------------------------------x */}
                <div className="col-xl-4 col-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Card Expense Statistics</h3>
                        </div>
                        <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white d-flex align-items-center">
                            <div style={{ width: "100%" }} id="chart-pipe">
                                <Chart
                                    options={CardExpenseChart}
                                    series={CardExpenseChart.series}
                                    type={CardExpenseChart.chart.type}
                                    height={CardExpenseChart.chart.height}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*  x---------------------------------x Card List Section x---------------------------------x */}
                <div className="col-xl-8 col-lg-12">
                    <div className="card border-0 bg-transparent">
                        <div className="card-header justify-content-between">
                            <h3 className="col text-dark fs-5 fw-semibold ">Card List</h3>
                            <Link to="/" className="col text-dark text-end fs-5 fw-semibold d-block d-sm-none">See
                                all</Link>
                        </div>
                        <div className="card-body p-0 rounded-4">
                            <ul className="row li_animate list-unstyled" id="MyClients">
                                {CardListData.map((data, index) => (
                                    <li className="col-12" key={index}>
                                        <div className="bg-card p-3 mt-3 mx-3  rounded-4">
                                            <div className="row g-3 align-items-center">
                                                {/* Avatar and Card Type */}
                                                <div className="col-lg-3 col-md-12 mb-2 mb-lg-0">
                                                    <div className="d-flex gap-3 align-items-center">
                                                        <div className={`avatar lg no-thumbnail rounded-4 ${data.icon_bg}`}>
                                                            {data.icon}
                                                        </div>
                                                        <div>
                                                            <h6 className="mb-1">Card Type</h6>
                                                            <span className="text-muted">{data.cardType}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bank, Card Number, Owner Name, and View Details */}
                                                <div className="col-lg-9 col-md-12">
                                                    <ul className="list-unstyled d-flex gap-xl-4 gap-3 mb-0 justify-content-between mb-0 flex-column flex-md-row align-items-sm-center">
                                                        <li>
                                                            <div>
                                                                <h6 className="mb-1">Bank</h6>
                                                                <span className="text-muted">{data.BankName}</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div>
                                                                <h6 className="mb-1">Card Number</h6>
                                                                <span className="text-muted">{data.CardNumber}</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div>
                                                                <h6 className="mb-1">Name on Card</h6>
                                                                <span className="text-muted">{data.CardOwnerName}</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="btn link-offset-2 link-underline link-underline-opacity-0 text-primary"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#exampleModal"
                                                                data-bs-whatever="@fat"
                                                            >
                                                                View Details
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            {/*  x---------------------------------x Add New Card/Card Setting Section x---------------------------------x */}
            <div className="row g-sm-3 g-1 flex-wrap-reverse row-deck mt-2">
                {/*  x---------------------------------x Add New Card x---------------------------------x */}
                <div className="col-lg-8 col-md-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Add New Card</h3>
                        </div>
                        <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
                            <div>
                                <p className="text-secondary opacity-75 fs-6 fw-normal   m-0">Credit Card
                                    generally means a plastic card issued by Scheduled Commercial Banks
                                    assigned to a Cardholder, with a credit limit, that can be used to
                                    purchase goods and services on credit or obtain cash advances.</p>
                            </div>
                            <form>
                                <div className="row g-4 mt-3">
                                    <div className=" col-md-6">
                                        <label htmlFor="card-type" className="form-label">Card Type</label>
                                        <input type="email" className="form-control form-control-lg"
                                            id="card-type" placeholder="Classic" />
                                    </div>
                                    <div className=" col-md-6">
                                        <label htmlFor="exampleInputPassword1" className="form-label">Name On
                                            Card</label>
                                        <input type="password" className="form-control form-control-lg"
                                            id="exampleInputPassword1" placeholder="My Cards" />
                                    </div>
                                    <div className=" col-md-6">
                                        <label htmlFor="exampleInputnumber" className="form-label">Card
                                            Number</label>
                                        <input type="password" className="form-control form-control-lg"
                                            id="exampleInputnumber" placeholder="**** **** **** ****" />
                                    </div>
                                    <div className=" col-md-6 ">
                                        <label htmlFor="datepicker" className="form-label">Expiration
                                            Date</label>
                                        <input type="date" id="datepicker"
                                            className="form-control form-control-lg" />
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="row">
                                            <div className="col-xl-3 col-lg-4">
                                                <button type="submit" className="btn btn-primary">Add
                                                    Card</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                {/*  x---------------------------------x Card Setting Section x---------------------------------x */}
                <div className="col-lg-4 col-md-12">
                    <div className="card border-0 bg-transparent h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Card Setting</h3>
                        </div>
                        <div className="card-body bg-white rounded-4">
                            <div className="d-flex flex-column justify-content-between h-100">
                                {CardSettingData.map((data, index) => {
                                    return (
                                        <div className="d-flex justify-content-between my-1" key={index}>
                                            <div className="d-flex">
                                                <div className={`no-thumbnail avatar lg rounded-4 me-3 ${data.icon_Bg}`}>
                                                    {data.icon}
                                                </div>
                                                <div>
                                                    <div>
                                                        <p className="text-dark  fs-6 fw-medium  m-0">{data.Heading}</p>
                                                        <p className="text-muted fs-6 fw-normal  m-0">{data.Description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* x---------------------------------x Card List pop up x---------------------------------x */}
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5 text-dark" id="exampleModalLabel">Card Details</h1>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="card">
                                <div className="card-body mb-0 pb-0">
                                    <div className="table-responsive">
                                        <table id="loans-table" className="myDataTable table table-hover m-b-0 "
                                            style={{ width: "100%", }}>
                                            <tbody>
                                                <tr>
                                                    <td>Card Type:</td>
                                                    <td>Credit Card</td>
                                                </tr>
                                                <tr>
                                                    <td>Bank Name:</td>
                                                    <td>Sample Bank</td>
                                                </tr>
                                                <tr>
                                                    <td>Card Number:</td>
                                                    <td>**** **** **** 1234</td>
                                                </tr>
                                                <tr>
                                                    <td>Cardholder Name:</td>
                                                    <td>John Doe</td>
                                                </tr>
                                                <tr>
                                                    <td>Expiration Date:</td>
                                                    <td>12/25</td>
                                                </tr>
                                                <tr>
                                                    <td>CVV/CVC:</td>
                                                    <td>***</td>
                                                </tr>
                                                <tr>
                                                    <td>Billing Address:</td>
                                                    <td>1234 Elm Street, Springfield, IL</td>
                                                </tr>
                                                <tr>
                                                    <td>Additional Information:</td>
                                                    <td>Rewards Program: 2% Cashback</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreditCards